module.exports = __webpack_public_path__ + "static/media/Ad-Server-Dashboard-5.a6644934.jpg";